module.exports = __webpack_public_path__ + "ptc_momoro_E2.6117528e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_E2.jpg
// module id = CGHv
// module chunks = 0